
<template>
    <div class="header"></div>
    <div>
        <!-- <AppTopBar @menu-toggle="onMenuToggle" /> -->
        <Menubar :model="items" v-if="isAuthenticated" class="test">
            <template #start>
                <!-- <img alt="logo" src="https://ncup-www.geoprostor.net/Data/Sites/-1/media/images/ncup-logo-min.svg" height="40" class="mr-2"> -->
                <img alt="logo" src="@/assets/LOGO-MZIE-SLO-2-BARVEN.svg" height="60" class="mr-2">
            </template>
            <template #end>
                <Button icon="pi pi-power-off" class="p-button-raised p-button-rounded p-button-warning" @click="onLogout" />
                <!-- <a href="#" @click.prevent="onLogout">Logout</a> -->
            </template>
        </Menubar>
        <!-- <router-view /> -->
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<!--

<div class="testheader"><span>Tole naj bi bilo vsepovsod!</span></div>
  <div class="row">
    <div class="col-sm-8 offset-sm-2">
      <div id="nav">
        <router-link to="/">Home</router-link> |
        <router-link to="/AddEnergySite">Add Energy Site</router-link> 
        <span v-if="!isAuthenticated">
          |
          <router-link to="/Login">Login</router-link> 
        </span>
        <span v-if="isAuthenticated">
          |           
          <a href="#" @click.prevent="onLogout">Logout</a>
        </span>
      </div>
      <div class="alert alert-info" v-if="isBusy">Loading...</div>
      <div class="alert alert-danger" v-if="error">{{ error }}</div>
      <router-view />
    </div>
  </div>

</template>
  -->

<script>
  import store from "@/store"
  import { computed } from "vue"
  import { ref } from 'vue';
  import router from './router'
  import AppTopBar from './AppTopbar.vue';

  export default {
    setup() {
      //console.log('App.vue SETUP CALL !!!')
    
    // poklicem store metodo da se inicializira, da prebere iz persisten stora token in expiration time
    //const tmpState = store.state
    //console.log(tmpState)
      store.dispatch("InitMyStore");
      store.commit('initialiseStore');

      console.log('KONEC INIT');

      // translated: computed(() => store.getters.getTranslate),
      const translated = computed(() => store.getters.getTranslate);


    const items = ref([      
                {
                  label: translated.value('menuNP'), //'Nadzorna plošča',
                  icon:'pi pi-fw pi-chart-bar',
                  visible: () => (store.getters.isAuthenticated),
                  command:() => { router.push({ name: 'Dashboard'}) }
                },             
                {
                  label: translated.value('menuPP'), //'Polnilni parki',
                  icon:'pi pi-fw pi-flag',
                  visible: () => (store.getters.isAuthenticated && (store.getters.isInRole('CAdmin') || store.getters.isInRole('CUser'))),
                  command:() => { router.push({ name: 'EnergySites'}) }
                },
                {
                  label: translated.value('menuSifranti'), //'Šifranti',
                  icon:'pi pi-id-card',
                  visible: () => (store.getters.isAuthenticated && store.getters.isInRole('MAdmin')),
                  items: [
                    {
                      label: translated.value('menuPS'), //'Plačilna sredstva',
                      icon:'pi pi-money-bill',
                      command:() => { router.push({ name: 'PaymentTypes'}) }
                    },
                    {
                      label: translated.value('menuFIN'), //'Financiranja',
                      icon:'pi pi-money-bill',
                      command:() => { router.push({ name: 'Financed'}) }
                    },
                    {
                      label: translated.value('menuFINSource'), //'Viri Financiranja',
                      icon:'pi pi-money-bill',                  
                      command:() => { router.push({ name: 'FinancedSources'}) }
                    },
                    {
                      label: translated.value('menuReceivingSupportCompaniesPlural'),
                      icon:'pi pi-building',
                      command:() => { router.push({ name: 'ReceivingSupportCompanies'}) }
                    }                                                              
                  ]                  
                },
                {
                  label: translated.value('menuCO'), //'Podjetja',
                  icon:'pi pi-id-card',
                  visible: () => (store.getters.isAuthenticated && store.getters.isInRole('MAdmin')),
                  items: [
                    {
                      label: translated.value('menuPON'), //'Novo registrirana',
                      icon:'pi pi-money-bill',
                      command:() => { router.push({ name: 'Companies', params: { approved: 0 } }) },
                    },
                    {
                      label: translated.value('menuPOMSP'), //'Nepotrjene MSP/CPO',
                      icon:'pi pi-money-bill',
                      command:() => { router.push({ name: 'Companies', params: { approved: 2 } }) },
                    },
                    {
                      label: translated.value('menuPOPO'), //'Potrjena',
                      icon:'pi pi-money-bill',
                      command:() => { router.push({ name: 'Companies', params: { approved: 1 } }) },
                    },
                    {
                      label: translated.value('menuCommunication'), //'Pregled komunikacije',
                      icon:'pi pi-money-bill',
                      command:() => { router.push({ name: 'CompanyCommunication' }) },
                    },
                    {
                      label: translated.value('menuRefillPointsOverview'), //'Pregled polnilnih mest',
                      icon:'pi pi-money-bill',
                      command:() => { router.push({ name: 'RefillPointsOverview' }) },
                    }
                  ]                  
                },
                {
                  label: translated.value('menuReports'), //'Dokumenti',
                  icon:'pi pi-print',
                  visible: () => (store.getters.isAuthenticated && store.getters.isInRole('Reporting') && (store.getters.isInRole('MAdmin') || store.getters.isInRole('MUser'))),
                  command:() => { router.push({ name: 'Documents'}) }
                },    
                {
                  label: 'OCPI parametri',
                  icon:'pi pi-server',
                  visible: () => (store.getters.isAuthenticated && store.getters.isInRole('CAdmin') ),
                  command:() => { router.push({ name: 'DataConnections', params: { companyid: '00000000-0000-0000-0000-000000000000' }}) }
                },                           
            ]);

      return {

        isBusy: computed(() => store.state.isBusy),
        error: computed(() => store.state.error),
        isAuthenticated: computed(() => store.getters.isAuthenticated),        
        onLogout() {
          store.dispatch("logout")
          router.push({ name: 'Login' })
        },
        items: items
      }
    },
    beforeCreate: function() {
        //console.log("beforeCreate APP . VUE ===================================================================================");
    },  
    mounted: function() {
        //console.log("mounted APP. VUE ===================================================================================");
    },    
    created: function() {
      //console.log("CREATED APP. VUE ===================================================================================");
      document.title = "Prometej v1.0";
    } , 
    //computed: {
      /*
      getMyTranslate(key) {
        console.log('PRIŠEL V getMyTranslate!!!!!!!!!!!!!!!!!!!!!!');
          return store.getters.getTranslate(key)
        }
        */
    //},
    methods: {        
        onWrapperClick() {
            console.log('onWrapperClick');
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
            this.menuClick = false;
        },
        onMenuToggle() {
            console.log('MENU TOGGLE')
            this.menuClick = true;
            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}
                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }
            event.preventDefault();
        },
        isDesktop() {
            return window.innerWidth > 1024;
        },        
    },    
    components: {
        'AppTopBar': AppTopBar
    }    
  }
</script>

<style lang="scss">

  @use './App.scss';
  // @import './App.scss';

  body {
    overflow-y: scroll;
  }

  body.p-overflow-hidden {
    padding-right: 16px;
  }

  #app {
    max-width: 1200px;
    margin: 0 auto;    
  }
  .p-menubar {
      border: none !important;
  }
  // span.p-menuitem-text {
  //     color: whitesmoke !important;
  // }

  // span.p-menuitem-icon {
  //     color: whitesmoke !important;
  // }

  // .p-menubar.p-component {
  //     background: #495057;
  // }


  // .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:focus {
  //     box-shadow: initial !important;
  // }

  // .globalDialog .p-dialog-header {
  //     height: 40px;
  //     border-bottom: 1px solid darkgray;
  //     //padding: 1.9rem 1.5rem 1.1rem 1.5rem;
  // }

  // .p-dialog-header h4 {
  //   margin-bottom: initial;
  // }

// li.p-menuitem.p-menuitem-active a:hover {
//     background:  #3f535d !important;
// }

// .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
//     background: #607d8b !important;
// }
  
// li.p-menuitem.p-menuitem-active a {
//     background: #607d8b !important;    
// }

// ul.p-submenu-list {
//     background: #607d8b !important;
// }

// .p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link, .p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover {
//     background: #607d8b !important;
// }

.cardheader h5 {
    display: contents;
    font-weight: 500;
	  // margin:3px 3px 3px 10px;
}

.cardheader {
    background: #ced4da;
    color: #224a23;
    padding: 0px 20px;
	  height: 50px;
    display: flex;
    align-items: center;
}


  .logindiv {
    max-width: 400px;
    margin: 0 auto;
  }

  .logindiv .passdiv {
    margin-top:30px;
  }

  .logindiv .errordiv {
    height: 10px;
    padding-top: 40px;
    text-align: center;
  }  

  .logindiv input {
    padding: 10px !important;    
    // border: 0 !important;
    border-bottom: 1px solid #ddd !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .logindiv .p-password.p-component.p-inputwrapper {
    width: 100%;
}

// .p-menuitem-content {background-color: transparent !important;}
// .p-menuitem-content:hover { background-color: transparent;background: #607d8b !important; border-radius: 5px;}
// .p-menuitem-link:hover {background: #607d8b; border-radius: 5px;}


</style>
